var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFactorryInactiveIcon = function SvgFactorryInactiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M4.68 7.16a.83.83 0 0 1 .822-.702h2.33c.408 0 .757.298.822.702l1.554 9.715H3.125zM16.042 2.708H8.333c-.92 0-1.666.747-1.666 1.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "m9.658 11.042 2.356-1.32a.417.417 0 0 1 .62.364v1.58L16.4 9.695a.417.417 0 0 1 .61.37v6.811h-6.875"
  })));
};
export { SvgFactorryInactiveIcon as ReactComponent };
export default __webpack_public_path__ + "9a98bbc1fa46325cb9081f1b30de6db2.svg";